<script setup lang="ts">
    import { Skeleton } from '@/components/ui/skeleton';
</script>

<template>
    <div class="flex gap-2">
        <Skeleton class="size-6 rounded-full" />
        <div class="flex w-full flex-col gap-1.5 pt-1">
            <Skeleton class="h-4 w-full" />
            <Skeleton class="h-4 w-full" />
        </div>
    </div>
</template>
